import React, { Component } from "react";
import { withRouter } from 'react-router-dom';

import UI from "../../../actions/ui-helper";
import API from "../../../actions/api-helper";

import "./css/impressao.css";

class ImpressaoAtendimento extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {
    UI.loader("show", "Aguarde, gerando relatório...");
    API.get("/atendimentos/" + this.props.match.params.id)
      .then(function (json) {
        this.setState(json.data);
        UI.loader("hide");
      }.bind(this)).catch(function (json) {
        UI.alert(false, json.message);
      });
  }

  render() {
    if (!this.state.id) return false;

    let styleCabecalho = {
      fontSize: "14px",
      margimBottom: "20px"
    };
    let styleAssinatura = {
      width: "20%",
      margin: "8px",
      display: "inline-block",
      borderTop: "1px solid black",
      verticalAlign: "top"
    };
    let styleAlign = {
      verticalAlign: "top"
    };
    let styleLabel = {
      width: "15%",
      fontWeight: "700",
      display: "inline-block"
    };
    let styleDesc = {
      width: "85%",
      display: "inline-block"
    };

    // Dados do cabeçalho
    let empresa = this.props.usuario.empresa;
    let endereco = this.props.usuario.empresa.endereco;

    // Renderização da tabela
    return (
      <div className="report">
        <button className="btn btn-primary btn-float-right" onClick={() => window.print()}><i className="icon icon-printer"></i>Preparar para Impressão</button>
        <header className="report-header">
          <h2>{empresa.razaoSocial}</h2>
          <h3>CNPJ: {empresa.cnpj}</h3>
          <hr></hr>
        </header>
        <div style={styleCabecalho}>
          <span style={styleLabel}>DATA DO ATENDIMENTO:</span>{this.state.data}<br />
          <span style={styleLabel}>HORÁRIO:</span>{this.state.horaEntrada.substr(0, 5)} às {this.state.horaSaida.substr(0, 5)}h<br /><br />
          <span style={styleLabel}>PROFISSIONAIS:</span>
          {this.state.valores.map(
            (valor, i) => {
              let last = this.state.valores.length - 1;
              let separador = (i + 1) === last ? ' e ' : (i + 1) < last ? ', ' : '';
              return (<span key={i}>{valor.usuarioNome}{separador}</span>);
            })}
          <br />
          <span style={styleLabel}>CÓDIGO:</span>{this.state.procedimento.codigo}<br />
          <div style={styleAlign}>
            <span style={styleLabel}>ATIVIDADE:</span>
            <span style={styleDesc}>{this.state.procedimento.descricao}</span>
          </div><br />
          <span style={styleLabel}>DESCRIÇÃO:</span>{this.state.descricao}
          <hr></hr>
          <span style={styleLabel}>PACIENTE:</span>ID {this.state.paciente.idCismepar} - {this.state.paciente.nome}<br />
          <span style={styleLabel}>DATA NASCIMENTO:</span>{this.state.paciente.dataNascimento}
        </div>
        <footer className="report-footer">
          <div>{this.state.valores.map(function (valor, i) {
            return (<div style={styleAssinatura} key={i}>{valor.usuarioNome}</div>)
          })}</div>
          <hr></hr>
          {endereco.logradouro} {endereco.numero} - {endereco.bairro} - cep {endereco.cep}<br />
          {empresa.telefoneComercial} - {empresa.telefoneCelular}<br />
          {empresa.email}<br />
          {endereco.cidade} - {endereco.estado}
        </footer>
      </div>
    );
  }
}

export default withRouter(ImpressaoAtendimento);